import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../../components/Button";
import CloseIcon from "../../../../assets/icons/close.svg";
import styles from "./ChangeName.module.scss";
import { sendAnalyticsEvent, sendMessage } from "../../../../lib/postMessage";
import { isValidName } from "../../../../lib/string";
import CrossIcon from "../../../../assets/icons/cross_icon.svg";
import { EDITNAME, FAVOURITES } from "../../../../constants/analytics";

export const ChangeName = () => {
  const { selectedFavourite, storedFavourites } = useSelector(
    (state) => state.filter
  );
  const dispatch = useDispatch();
  const [name, setName] = useState(
    storedFavourites.find((favourite) => favourite.id === selectedFavourite)
      .name
  );
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isValidName(name)) {
      setError("Whoops, name not allowed. Please use a different name.");
      return;
    }

    setError(""); // Clear any existing errors

    const favouriteIndex = storedFavourites.findIndex(
      (favourite) => favourite.id === selectedFavourite
    );

    const favourites = [...storedFavourites];
    favourites[favouriteIndex].name = name;

    dispatch({
      type: "EDIT_FAVOURITE",
      payload: name,
    });

    sendMessage({
      type: "UpdateFavourites",
      payload: favourites,
    });

    sendAnalyticsEvent({
      event: FAVOURITES,
      type:
        favourites[favouriteIndex].type.charAt(0).toUpperCase() +
        favourites[favouriteIndex].type.slice(1),
      action: EDITNAME,
    });

    dispatch({
      type: "SET_ACTIVE_VIEW",
      payload: "",
    });
  };

  const clearInput = () => {
    setName("");
    setError("");
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setName(inputValue);

    if (inputValue === "") {
      setError(""); // Clear error if input is empty
      return;
    }

    if (!isValidName(inputValue)) {
      setError("Whoops, name not allowed. Please use a different name.");
    } else {
      setError(""); // Clear error if input is valid
    }
  };

  const hasError = Boolean(!!error);

  return (
    <form onSubmit={handleSubmit} className={styles.changeNameForm}>
      <label htmlFor="name" className={styles.changeNameLabel}>
        Name
      </label>
      <div
        className={`${styles.changeNameInputContainer} ${
          hasError ? styles.changeNameInputError : ""
        }`}
      >
        <input
          type="text"
          id="name"
          className={styles.changeNameInput}
          value={name}
          onChange={handleChange}
        />
        <button
          type="button"
          className={styles.changeNameClearButton}
          onClick={clearInput}
        >
          <img src={CloseIcon} alt="clear input" />
        </button>
      </div>
      {Boolean(!!error) && (
        <div className={styles.changeNameErrorMessage}>
          <img height={16} width={16} src={CrossIcon} alt="error" />
          <p className={styles.changeNameErrorMessageText}>{error}</p>
        </div>
      )}
      <Button
        styleClass={styles.changeNameButton}
        type="submit"
        disabled={!name || hasError}
      >
        Save name
      </Button>
    </form>
  );
};
